import { constantsData, formFieldNamesData } from "@/data";
import { optionsData } from "@/data/options";
import { FieldTypeEnum } from "@/enums";

const {
    condition,
    firstAmountType,
    secondAmountType,
} = constantsData.forms.dataSources.calculate;

const {
    condition: conditionFieldName,
    firstAmountType: firstAmountTypeFieldName,
    secondAmountType: secondAmountTypeFieldName,
} = formFieldNamesData;

export const calculateOfflineDataSourceAmountFieldFormData = [
    {
        hasOptionFormat: true,
        label: firstAmountType.label,
        name: firstAmountTypeFieldName,
        options: optionsData.dataSource.calculate.transactionAmountTypes,
        type: FieldTypeEnum.SELECT,
    },
    {
        label: condition.label,
        name: conditionFieldName,
        options: optionsData.dataSource.calculate.conditions,
        type: FieldTypeEnum.SELECT,
    },
    {
        hasOptionFormat: true,
        label: secondAmountType.label,
        name: secondAmountTypeFieldName,
        options: optionsData.dataSource.calculate.transactionAmountTypes,
        type: FieldTypeEnum.SELECT,
    },
];
